// extracted by mini-css-extract-plugin
export default {"avaliableOffers":"AvaliableOffers_avaliableOffers__RbV5j"};